module.exports = __webpack_public_path__ + "img/BrandImg3.897dd04b.png";